import React from 'react';
import './EmptyState.css';

function EmptyState({
    icon = '📭',
    title,
    message,
    action = null,
    actionText = null,
    onAction = null
}) {
    return (
        <div className="empty-state">
            <span className="empty-state-icon">{icon}</span>
            <h3 className="empty-state-title">{title}</h3>
            {message && <p className="empty-state-message">{message}</p>}
            {action && actionText && onAction && (
                <button className="empty-state-action" onClick={onAction}>
                    {action} {actionText}
                </button>
            )}
        </div>
    );
}

export default EmptyState;
